import { Site } from './';
import { Product } from './Product';
import { Vehicle } from './Vehicle';
import { ResourceType } from './ResourceType';

export interface PlannedOperation {
    id?: number;
    resource?: string;
    startSite: Site;
    finishSite: Site;
    startTime?: string;
    finishTime?: string;
    typeId: number;
    type: PlannedOperationType;
    typeString: string;
    linkedObject?: string;
    mainResourceId: string;
    mainResource: Vehicle;
    linkedResource: Vehicle;
    linkedResourceId: string;
    mainResourceType?: ResourceType;
    linkedResourceType?: ResourceType;
    resourceIds?: string[];
    resources?: Vehicle[];
    productTypes: string;
    productTypesId: number[];
    volume?: number;
    area?: string;
    areaPlaces: string;
    areaPlacesId: number[];
    assembleInAdvance?: boolean;
    packs?: number;
    flow?: number;
    weight?: number;
    // calced
    timeDuration?: string;
}

export enum PlannedOperationType {
    UNLOADING = 'Unloading',
    LOADING = 'Loading',
    RELOCATION = 'Relocation',
    WAITING = 'Waiting',
    EMPTY_RELOCATION = 'EmptyRelocation',
    INACTIVE = 'Inactive',
    PREPARATION = 'Preparation',
    COMPLETION = 'Completion'
}

export interface PlannedOperationInfo {
    id?: number;
    quantity: number;
    startSiteId?: number;
    finishSiteId?: number;
    preferredTime?: string;
    startTime?: string;
    finishTime?: string;
    plannedFinishTime?: string;
    orderNumber?: string;
    productId?: number;
    sourceId?: number;
    destinationId?: number;
    area?: string;
    storageCode?: string;
    areaPlaceCode?: string;
    consignment?: string;
    externalData?: string;
    product: Product;
    weight: number;
    volume: number;
    productType: ResourceType;
    productTypesId: number[];
}
